<script>
// Tri alphabétique des pages/groupes, choix partagé entre les écrans via localStorage
const STORAGE_KEY = 'selectPageSortMode'

export default {
  data() {
    return {
      pageSortMode: localStorage.getItem(STORAGE_KEY) === 'alpha' ? 'alpha' : 'default'
    }
  },

  computed: {
    isPageSortAlpha() {
      return this.pageSortMode === 'alpha'
    }
  },

  methods: {
    togglePageSortMode() {
      this.pageSortMode = this.isPageSortAlpha ? 'default' : 'alpha'
      localStorage.setItem(STORAGE_KEY, this.pageSortMode)
    },

    comparePageNames(a, b) {
      return ((a && a.name) || '').trim().localeCompare(((b && b.name) || '').trim(), undefined, { sensitivity: 'base', numeric: true })
    },

    // Renvoie une copie triée par nom si le tri alpha est actif, sinon la liste telle quelle
    sortByPageName(list, getItem = item => item) {
      if (!this.isPageSortAlpha || !list) return list
      return [...list].sort((a, b) => this.comparePageNames(getItem(a), getItem(b)))
    }
  }
}
</script>
